import React from 'react';
import { STATUS_LABELS } from '../../utils/billSteps';

const STATUS_TONE = {
  service_completed: 'muted',
  customer_identified: 'muted',
  bill_draft: 'warn',
  awaiting_payment: 'warn',
  payment_received: 'info',
  under_review: 'info',
  approved: 'info',
  finalized: 'ok',
  delivered: 'ok',
};

export function BillStatus({ status }) {
  return <span className={`dp-pill dp-pill--${STATUS_TONE[status] || 'muted'}`}>{STATUS_LABELS[status] || status}</span>;
}

const QUEUE_TONE = { booked: 'muted', active: 'muted', in_service: 'info', service_taken: 'ok', completed: 'ok' };

export function QueueStatus({ status, label }) {
  return <span className={`dp-pill dp-pill--${QUEUE_TONE[status] || 'muted'}`}>{label || status}</span>;
}

const CHANNEL_LABELS = {
  whatsapp: 'WhatsApp',
  instagram: 'Instagram',
  sarvam: 'AI voice call',
  voice: 'AI voice call',
  walk_in: 'Walk-in',
  presentation_demo: 'Digital check-in',
  passport_face: 'Passport',
  face_identity: 'Face check-in',
  guest_qr: 'Guest QR',
};

/** Where a queue entry came from: Demo Engagement (+ channel) or a branch check-in. */
export function SourceBadge({ entry }) {
  const engagement = entry.source === 'demo_engagement';
  const channel = CHANNEL_LABELS[entry.channel] || entry.channel;
  return (
    <span className={`dp-source dp-source--${engagement ? 'engagement' : 'checkin'}`}>
      {engagement ? 'Engagement' : entry.franchise_name || 'Check-in'}
      {channel ? <em>{channel}</em> : null}
    </span>
  );
}
